import {
  React,
  Component,
  withCookies,
} from 'imports/CommonImports';

import {Validation} from 'imports/ComponentsImports';

 const styles = {
   signatureBar: {
     backgroundColor:'#FFFFFF',

     marginLeft:'-22px',
     marginRight:'-22px',
     display:'flex',
     paddingTop:'5px',
     paddingBottom:'5px',
     boxShadow: '0px 0px 5px 1px #DDDDDD'
   },
   signatures: {
     width:'75%',
     display:'flex',
     flexDirection:'row',
     alignItems:'center',
     justifyContent: 'space-around'
   },
   person: {
     color:'#212f55',
     textAlign:'center',
     fontFamily: 'Lato',
     textTransform:'uppercase',
     fontSize:'10px'
   },
   title: {
     width:'25%'
   },
   text: {
     marginLeft:'20px',
     color:'#212f55',
     fontFamily: 'Lato',
     textTransform:'uppercase',
     fontSize:'14px'
   },
   signed: {
     color: '#388E3C',
     fontSize: '10px'
   },
   nosigned: {
     color: '#BF360C',
     fontSize: '10px'
   },
   waiting: {
     color: '#212f55',
     fontSize: '10px'
   }
 }

class ValidationBar extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={styles.signatureBar}>
        <div style={styles.title}>
          <p style={styles.text}>Proyecto en proceso de firma</p>
        </div>
        <div style={styles.signatures}>
          <Validation project={this.props.project} />
        </div>
      </div>
    );
  }
}

export default withCookies(ValidationBar);



// WEBPACK FOOTER //
// ./src/components/files/ValidationBar.js